// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c8ab0ed6","53":"afdb6b9c","122":"c8bcc595","290":"0e4c3464","468":"770dfde8","794":"d81d052d","801":"0a9e49a0","823":"452c749c","830":"1efe1eb0","986":"e75c6256"}[chunkId] + ".chunk.js";
};